module.exports = __webpack_public_path__ + "img/amazon.f42807c1.jpg";